import { useState } from 'react';
import { Controller } from 'react-hook-form';

import { FormRow } from '@gravity-ui/components';

import { Button, Icon, Select, Sheet } from '@gravity-ui/uikit';
import { Xmark } from '@gravity-ui/icons';

import styles from '../styles.module.scss';

export const ViolationsSelect = ({ isMobile, formText, control, formValues, violationsOptions, errors }: any) => {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<>
			{isMobile ? (
				<FormRow className={styles.info__row} label={formText.mainTypesViolations} required>
					<Controller
						control={control}
						name="violations"
						render={({ field: { onChange, onBlur, ref }, fieldState: { error } }) => {
							return (
								<Select
									filterable
									hasClear
									placeholder={formText.chooseViolations}
									className={styles.info__row__select}
									size="xl"
									value={[formValues.violations]}
									onUpdate={(values) => onChange?.(values[0])}
									options={violationsOptions}
									validationState={error ? 'invalid' : undefined}
									errorPlacement="inside"
									errorMessage={error?.message}
									onBlur={onBlur}
									ref={ref}
									open={isOpen}
									onOpenChange={setIsOpen}
									renderPopup={({ renderFilter, renderList }) => (
										<Sheet
											visible={isOpen}
											onClose={() => setIsOpen(false)}
											title="Выберите тип нарушения"
											className={styles.sheet}
										>
											<div className={styles.sheet__close}>
												<Button onClick={() => setIsOpen(false)} view="flat">
													<Icon data={Xmark} size={16} />
												</Button>
											</div>
											<div className={styles.sheet__content}>
												{renderFilter?.()}
												{renderList?.()}
											</div>
										</Sheet>
									)}
								/>
							);
						}}
					/>
				</FormRow>
			) : (
				<FormRow className={styles.info__row} label={formText.mainTypesViolations} required>
					<Controller
						control={control}
						name="violations"
						render={({ field: { onChange, onBlur, ref }, fieldState: { error } }) => (
							<Select
								filterable
								hasClear
								placeholder={formText.chooseViolations}
								className={styles.info__row__select}
								size="xl"
								value={[formValues.violations]}
								onUpdate={(values) => onChange?.(values[0])}
								options={violationsOptions}
								validationState={errors.gender ? 'invalid' : undefined}
								errorPlacement="inside"
								errorMessage={error?.message}
								onBlur={onBlur}
								ref={ref}
							/>
						)}
					/>
				</FormRow>
			)}
		</>
	);
};
